import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Nan = props => {
  var {
    Nan: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Nan');
  return null;
};
Nan.displayName = 'JVR.Nan';